import { useEffect } from "react";
import { delivoApi } from "../api";
import { initialAccountValues } from "../providers/AccountProvider/initialAccountValues";
import { useSearchParams } from "react-router-dom";
import { useAccountInfo } from "./useAccountInfo";

/**
 * Custom hook to fetch and manage account information.
 * @returns {AccountState} The current state of the account information, including the loading status.
 */

export function useFreshdeskSso() {
  const [searchParams] = useSearchParams();
  const { accountInfo, loading: isAccountInfoLoading } = useAccountInfo();
  const nonce = searchParams.get("nonce");
  const client_id = searchParams.get("client_id");
  const state = searchParams.get("state");
  const redirect_uri = searchParams.get("redirect_uri");

  useEffect(() => {
    if (isAccountInfoLoading) {
      return;
    }
    delivoApi
      .getSsoRedirectUrl({
        nonce,
        client_id,
        redirect_uri,
        state,
        sub: accountInfo.email,
        email: accountInfo.email,
        surname: "",
        givenname: accountInfo.contactName,
      })
      .then((token) => {
        const redirectUri = `${redirect_uri}?id_token=${token}&state=${encodeURIComponent(state)}`;
        window.location.replace(redirectUri, "_blank");
      });
  }, [
    client_id,
    redirect_uri,
    state,
    nonce,
    isAccountInfoLoading,
    accountInfo.contactName,
    accountInfo.email,
  ]);
}
